// extracted by mini-css-extract-plugin
export default {"root":"DownloadButton_root__SadsU","downloadButton":"DownloadButton_downloadButton__H+IqL","animation":"DownloadButton_animation__u2jC1","example":"DownloadButton_example__8Wfe4"};